module.exports = __webpack_public_path__ + "img/refresh_icon.27c62675.png";